'use client';

import { THEME } from '@/app/lib/constants/config';
import styles from './sidebar-navigation-item-with-icon.module.css';

import { SidebarNavItemWithIcon } from '@/app/lib/schemas/types/shared';
import { Badge, Button, Flex } from '@radix-ui/themes';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import React from 'react';

interface SidebarButtonProps {
  children: React.ReactNode;
  isActive: boolean;
  onClick?: () => void;
}

const SidebarButton = React.forwardRef<HTMLButtonElement, SidebarButtonProps>(
  ({ children, isActive, onClick, ...props }, ref) => {
    return (
      <Button
        ref={ref}
        onClick={onClick}
        variant='ghost'
        color={isActive ? 'jade' : 'gray'}
        style={{ width: '100%', justifyContent: 'flex-start' }}
        {...props}
      >
        <Flex
          gap='2'
          justify='center'
        >
          {children}
        </Flex>
      </Button>
    );
  }
);

SidebarButton.displayName = 'SidebarButton';

interface Props {
  item: SidebarNavItemWithIcon;
  onClick?: () => void;
}

const SidebarNavigationItemWithIcon = ({ item, onClick }: Props) => {
  return (
    <Link
      href={item.path}
      passHref
      className={styles.Anchor}
    >
      <SidebarButton
        isActive={usePathname().includes(item.path)}
        onClick={onClick}
      >
        <Flex
          align='center'
          gap='2'
        >
          {item.icon}
          {item.label}
          {item.commingSoon && (
            <Badge
              variant='solid'
              radius={THEME.badgeRadius}
              color='gold'
            >
              Скоро!
            </Badge>
          )}
        </Flex>
      </SidebarButton>
    </Link>
  );
};
export default SidebarNavigationItemWithIcon;
